import React, { Component } from 'react';
import AppConfig from '../../../../utils/common/DomainConfiguration';
// import profileImg from "../../../../utils/images/profileImg.png";

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class PhysicianInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMute: true,
            isInitialized: false,
        };
    }

    //componentDidMount
    componentDidMount() {
        const isEducatorMuted = sessionStorage.getItem('isEducatorMuted');
        if (isEducatorMuted !== null) {
            this.setState({
                isMute: isEducatorMuted === 'true',
                isInitialized: true,
            });
        } else {
            this.setState({ isInitialized: true });
        }
    }

    //componentDidUpdate
    componentDidUpdate(prevProps, prevState) {
        const isEducatorMuted = sessionStorage.getItem('isEducatorMuted');
        if (isEducatorMuted !== null && prevState.isMute !== (isEducatorMuted === 'true')) {
            this.setState({ isMute: isEducatorMuted === 'true' });
        }
    }

    render() {
        const {
            // videoCallDetails,
            minWidth,
            studentDetails,
            streams,
            isClassRoom,
            hasUrlParams,
            sessionTypeParams,
            isConferenceCall
        } = this.props;
        const educatorNameFromUrl = this.props.educatorName;

        // Determine which stream represents the educator/owner, with
        // safeguards for different naming patterns across session types
        // (classroom, group via URL, one-to-one, etc.).
        let educatorStreams = null;
        if (isClassRoom || hasUrlParams || sessionTypeParams || isConferenceCall) {
            if (streams && streams.length) {
                educatorStreams = streams.find((e) => {
                    if (!e) return false;
                    // Highest priority: explicit educatorName from URL params
                    if (educatorNameFromUrl && e.name === educatorNameFromUrl) {
                        return true;
                    }
                    // Next: match configured tutor name when available
                    if (studentDetails?.tutor?.name && e.name === studentDetails.tutor.name) {
                        return true;
                    }
                    // Fallback to legacy "Educator" label
                    return e.name === 'Educator';
                });

                // Final fallback: first non-screen stream or first stream
                if (!educatorStreams) {
                    educatorStreams = streams.find((e) => e && e.name !== 'screen') || streams[0];
                }
            }
        } else {
            educatorStreams = streams && streams.length ? streams[0] : null;
        }
        // const { profileImage } = videoCallDetails;
        const microphoneIconClass = this.state.isMute
            ? 'fas fa-microphone-slash text-red p-1'
            : 'far fa-microphone p-2 text-black';

        return (
            <div className="text-white bg-dateselect">
                <div className="flex items-center justify-between gap-3 p-3 flex-view">
                    <div className="flex flex-col justify-center flex-1 overflow-hidden">
                        <p
                            className="text-base text-white sm:text-lg"
                            title={
                                this.props.hasUrlParams
                                    ? this.props.educatorName
                                    : studentDetails.tutor?.name
                            }
                        >
                            {this.props.hasUrlParams && (
                                <b>
                                    {(this.props.educatorName || '').length > 25
                                        ? `${this.props.educatorName.slice(0, 25)}...`
                                        : this.props.educatorName || ''}
                                </b>
                            )}
                            <b>{studentDetails.tutor?.name}</b>
                        </p>
                        {!this.props.hasUrlParams && !this.props.sessionTypeParams && (
                            <p className="text-sm text-white break-words sm:text-base">
                                {AppConfig.labels.channelName} :{' '}
                                {studentDetails.expertiseCategory || '-'}
                                <br />
                                Element: {studentDetails.expertise || '-'}
                            </p>
                        )}
                    </div>

                    <div className="relative flex-shrink-0 w-8 h-8 mr-2">
                        {!this.props.isBroadCast ? (
                            <>
                                {streams?.length !== 0 && educatorStreams?.hasAudio && (
                                    <span className="absolute inline-flex w-8 h-8 bg-green-400 rounded-full opacity-75 animate-ping"></span>
                                )}
                                <span
                                    className={`absolute inline-flex h-8 w-8 rounded-full items-center justify-center ${
                                        streams?.length === 0 || educatorStreams?.hasAudio
                                            ? 'bg-green-500 text-white'
                                            : 'bg-red-500 text-white'
                                    }`}
                                    style={{ zIndex: 99 }}
                                >
                                    <i
                                        className={`fa-sm ${
                                            streams?.length === 0 || educatorStreams?.hasAudio
                                                ? 'far fa-microphone'
                                                : 'fas fa-microphone-slash'
                                        }`}
                                    />
                                    {/* <div className="circle-img">
              <img
                className="w-full h-full"
                src={
                  studentDetails.tutor?.image
                    ? studentDetails.tutor?.image
                    : profileImg
                }
                alt=""
                onClick={() => {
                  this.isOpenModal(profileImage);
                }}
              />
            </div> */}
                                </span>
                            </>
                        ) : (
                            <span
                                className="absolute bottom-0 right-0 flex items-center justify-center w-8 h-8 bg-white rounded-full"
                                style={{ zIndex: 99 }}
                            >
                                {this.state.isInitialized && (
                                    <i className={`fa-sm ${microphoneIconClass} fa-lg`} />
                                )}
                            </span>
                        )}
                    </div>

                    {minWidth ? <div className="flex-component" /> : ''}
                </div>
            </div>
        );
    }
}

export default PhysicianInformation;
